import { render, staticRenderFns } from "./CTPractitionerComponent.vue?vue&type=template&id=30831515&scoped=true&"
import script from "./CTPractitionerComponent.vue?vue&type=script&lang=js&"
export * from "./CTPractitionerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30831515",
  null
  
)

export default component.exports